export default __webpack_public_path__ + "static/media/bio.f99d3789.webp";